module.exports = __webpack_public_path__ + "media/images/features/6/album/feature-6-main-1-7e1ba9aae7bea0c32fab239ee635a214.png";